import { map } from "ramda";
import uuid from "uuid/v4";

import {
  findFormattersByType,
  formatObscuredCardNumberByType,
} from "helpers/credit_cards";

function formatCard(card) {
  const tokens = card.tokens ?? [card.token];
  const { type, lastFour } = card;

  return {
    tokens,
    cardUuid: uuid(),
    type,
    lowercaseType: findFormattersByType(type).lowercase,
    sentenceCaseType: findFormattersByType(type).prettyName,
    obscuredNumber: formatObscuredCardNumberByType(type, lastFour),
    lastFour,
    cardType: type,
    expiryYear: null,
    expiryMonth: null,
    zip: null,
  };
}

function formatCards(cards) {
  if (Array.isArray(cards)) {
    return map(formatCard, cards);
  }

  return [formatCard(cards)];
}

export default formatCards;
